module.exports = __webpack_public_path__ + "img/GSPO.e8a9711b.png";